export default "__VITE_ASSET__Dy$QIMVQ__"